import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../../context/Translator";
import { SidebarContext } from "../../../context/Sidebar";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Tab, Tabs, Form, Spinner, Alert, Modal, Badge } from "react-bootstrap";
import { LegendFieldComponent, LegendTextareaComponent, IconFieldComponent } from "../../../components/fields";
import { ButtonComponent } from "../../../components/elements";
import { FileUploadComponent } from "../../../components";
import PageLayout from "../../../layouts/PageLayout";
import axios from "axios";
import { FiUser, FiEdit2, FiDollarSign } from "react-icons/fi";
import { FaPaw } from "react-icons/fa";
import PetProceduresComponent from "../../../components/Admin/PetProceduresComponent";
import PetHistoryComponent from "../../../components/Admin/PetHistoryComponent";
import PetPhysicalExamComponent from "../../../components/Admin/PetPhysicalExamComponent";
import PetDiagnoseComponent from "../../../components/Admin/PetDiagnoseComponent";
import PetSurgeryComponent from "../../../components/Admin/PetSurgeryComponent";
import PetVaccineComponent from "../../../components/Admin/PetVaccineComponent";
import PetDewormingComponent from "../../../components/Admin/PetDewormingComponent";
import PetLabTestComponent from "../../../components/Admin/PetLabTestComponent";
import PetGroomingComponent from "../../../components/Admin/PetGroomingComponent";
import PetFollowUpComponent from "../../../components/Admin/PetFollowUpComponent";
import PetCheckUpComponent from "../../../components/Admin/PetCheckUpComponent";
import PetRadiologyComponent from "../../../components/Admin/PetRadiologyComponent";
import PetInhousePrescriptionComponent from "../../../components/Admin/PetInhousePrescriptionComponent";
import PetHomePrescriptionComponent from "../../../components/Admin/PetHomePrescriptionComponent";
import PetInvoiceComponent from "../../../components/Admin/PetInvoiceComponent";
import Swal from "sweetalert2";
import moment from "moment";
import { MdDateRange, MdAccessTime } from "react-icons/md";
import CustomerSaleComponent from "../../../components/Admin/SaleCreatecomponent";
import PetTreatmentComponent from "../../../components/Admin/PetTreatmentComponent";
import Select from "react-select";

export default function AppointmentShowPage() {
    const { t } = useContext(TranslatorContext);
    const { setSidebar } = useContext(SidebarContext);
    const { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [appointment, setAppointment] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState("consultation");
    const AuthToken = localStorage.getItem("authToken");

    // Customer Balance States
    const [customerBalance, setCustomerBalance] = useState(null);
    const [saleBalance, setSaleBalance] = useState(null);
    const [totalBalance, setTotalBalance] = useState(0);
    const [loadingBalance, setLoadingBalance] = useState(false);

    // Edit Pet Modal States
    const [editPetModal, setEditPetModal] = useState(false);
    const [breeds, setBreeds] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [updateForm, setUpdateForm] = useState({
        id: null,
        name: '',
        breed_id: '',
        customer_id: '',
        age: '',
        color: '',
        male: '1',
        is_dead: false,
        birth_date: '',
        death_date: '',
        weight: '',
    });
    const [updateErrors, setUpdateErrors] = useState({});
    const [updateLoading, setUpdateLoading] = useState(false);

    // Add More Appointment States
    const [showAddAppointmentModal, setShowAddAppointmentModal] = useState(false);
    const [availablePets, setAvailablePets] = useState([]);
    const [selectedPet, setSelectedPet] = useState(null);
    const [loadingPets, setLoadingPets] = useState(false);
    const [creatingAppointment, setCreatingAppointment] = useState(false);
    const [proceduresList, setProceduresList] = useState([]);
    const [selectedProcedures, setSelectedProcedures] = useState([]);

    // New Pet Creation States for Add Appointment Modal
    const [showPetCreationModal, setShowPetCreationModal] = useState(false);
    const [breedsList, setBreedsList] = useState([]);
    const [newPetForm, setNewPetForm] = useState({
        name: '',
        breed_id: '',
        age: '',
        color: '',
        male: '',
        weight: '',
        birth_date: ''
    });
    const [newPetErrors, setNewPetErrors] = useState({});
    const [creatingPet, setCreatingPet] = useState(false);

    const permissions = JSON.parse(localStorage.getItem("permissions")) || [];

    const hasPermission = (perm) => {
        return permissions.includes(perm);
    };


    // Fetch breeds for pet creation
    const [isLoadingBreeds, setIsLoadingBreeds] = useState(false);

    const fetchBreedsList = async () => {
        // Prevent multiple simultaneous calls
        if (isLoadingBreeds) return;

        setIsLoadingBreeds(true);
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/pet-breeds`,
                { headers: { Authorization: `Bearer ${AuthToken}` } }
            );
            const breedsData = response.data.data || response.data || [];
            setBreedsList(Array.isArray(breedsData) ? breedsData : []);
        } catch (error) {
            console.error("Error fetching breeds:", error);
            setBreedsList([]);
        } finally {
            setIsLoadingBreeds(false);
        }
    };

    // Fetch available pets for additional appointment
    const fetchAvailablePets = async () => {
        if (!appointment?.customer_id) return;

        setLoadingPets(true);
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/appointments-pets`,
                {
                    params: {
                        appointment_id: appointment.id,
                        customer_id: appointment.customer_id
                    },
                    headers: { Authorization: `Bearer ${AuthToken}` }
                }
            );

            console.log("API Response:", response.data); // Debug log

            if (response.data.success) {
                setAvailablePets(response.data.available_pets || []);

                // Set breeds from response
                if (response.data.breeds) {
                    const breedsData = response.data.breeds;
                    console.log("Breeds from API:", breedsData); // Debug log
                    setBreedsList(Array.isArray(breedsData) ? breedsData : []);
                }

                if (response.data.procedures) {
                    setProceduresList(response.data.procedures || []);
                }
            } else {
                setAvailablePets([]);
            }
        } catch (error) {
            console.error("Error fetching available pets:", error);
            setAvailablePets([]);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to load available pets"
            });
        } finally {
            setLoadingPets(false);
        }
    };

    // Function to handle modal open
    const handleOpenAddAppointment = () => {
        fetchAvailablePets();
        fetchBreedsList();
        fetchFilterData();
        setSelectedPet(null);
        setSelectedProcedures([]);
        setShowAddAppointmentModal(true);
    };

    // Handle new pet input change
    const handleNewPetChange = (e) => {
        const { name, value } = e.target;
        setNewPetForm(prev => ({ ...prev, [name]: value }));
        if (newPetErrors[name]) {
            setNewPetErrors(prev => ({ ...prev, [name]: "" }));
        }
    };

    // Handle new pet submission
    const handleCreateNewPet = async (e) => {
        e.preventDefault();
        setCreatingPet(true);
        setNewPetErrors({});

        // Validate required fields
        if (!newPetForm.name) {
            setNewPetErrors(prev => ({ ...prev, name: "Pet name is required" }));
            setCreatingPet(false);
            return;
        }
        if (!newPetForm.breed_id) {
            setNewPetErrors(prev => ({ ...prev, breed_id: "Breed is required" }));
            setCreatingPet(false);
            return;
        }
        if (!newPetForm.male) {
            setNewPetErrors(prev => ({ ...prev, male: "Gender is required" }));
            setCreatingPet(false);
            return;
        }

        const submitData = {
            name: newPetForm.name,
            breed_id: newPetForm.breed_id,
            customer_id: appointment.customer_id,
            age: newPetForm.age,
            color: newPetForm.color,
            male: newPetForm.male === 'male' ? 1 : 0,
            weight: newPetForm.weight,
            birth_date: newPetForm.birth_date
        };

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/pets`,
                submitData,
                {
                    headers: {
                        Authorization: `Bearer ${AuthToken}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            if (response.data.success) {
                const newPet = response.data.data;

                const newPetOption = {
                    id: newPet.id,
                    name: newPet.name,
                    breed: newPet.breed,
                    color: newPet.color,
                    male: newPet.male,
                    age: newPet.age
                };

                setAvailablePets(prev => [...prev, newPetOption]);
                setSelectedPet({
                    value: newPet.id,
                    label: `🐾 ${newPet.name} - ${newPet.breed?.name || 'Unknown Breed'} - ${newPet.color || ''}`,
                    pet: newPetOption
                });

                setShowPetCreationModal(false);
                setShowAddAppointmentModal(true);

                setNewPetForm({
                    name: '',
                    breed_id: '',
                    age: '',
                    color: '',
                    male: '',
                    weight: '',
                    birth_date: ''
                });

                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Pet created successfully!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            console.error("Error creating pet:", error);
            if (error.response?.status === 422) {
                setNewPetErrors(error.response.data.errors || {});
                Swal.fire({
                    icon: "error",
                    title: "Validation Error",
                    text: "Please check the form for errors"
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: error.response?.data?.message || "Failed to create pet"
                });
            }
        } finally {
            setCreatingPet(false);
        }
    };

    const handleCreateAdditionalAppointment = async () => {
        if (!selectedPet) {
            Swal.fire({
                icon: "warning",
                title: "Warning",
                text: "Please select a pet"
            });
            return;
        }

        setCreatingAppointment(true);
        try {
            // ✅ Single procedure fix
            const proceduresData = selectedProcedures
                ? [{ procedure_id: selectedProcedures.value, price: 0 }]
                : [];

            const payload = {
                pet_id: selectedPet.value,
                doctor_id: appointment.doctor_id,
                appointment_date: appointment.appointment_date,
                appointment_time_slot: appointment.appointment_time_slot,
                appointment_id: appointment.id,
                parent_id: appointment.parent_id || appointment.id,
                procedure_ids: proceduresData,
                notes: [],
                payments: []
            };

            console.log("Sending payload:", payload); // ✅ debug log

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/appointments`,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${AuthToken}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (response.data.success) {
                const newAppointmentId = response.data.data.id;

                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "New appointment created successfully!",
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 2000
                });

                setShowAddAppointmentModal(false);

                setTimeout(() => {
                    navigate(`/appointments/${newAppointmentId}`, {
                        state: {
                            procedureName: null,
                            isAdditionalAppointment: true,
                            preloadData: {
                                pet_id: selectedPet.value,
                                doctor_id: appointment.doctor_id,
                                appointment_date: appointment.appointment_date,
                                appointment_time_slot: appointment.appointment_time_slot,
                                customer_id: appointment.customer_id,
                                parent_id: appointment.parent_id || appointment.id,
                                source_appointment_id: appointment.id
                            }
                        }
                    });
                }, 1500);
            }
        } catch (error) {
            console.error("Error creating appointment:", error);
            console.log("Error response:", error.response?.data); // ✅ debug log
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.response?.data?.message || "Failed to create additional appointment"
            });
        } finally {
            setCreatingAppointment(false);
        }
    };

    // Map procedure names to tab keys
    const getProcedureTabMapping = (procedureName) => {
        if (!procedureName) return "consultation";

        const nameLC = procedureName.toLowerCase().trim();

        const tabMapping = {
            "surgery": "surgery",
            "vaccine": "vaccine",
            "sale": "sale",
            "vaccination": "vaccine",
            "deworming": "deworming",
            "grooming": "grooming",
            "follow-up": "follow-up",
            "check-up": "check-up",
            "follow up": "follow-up",
            "check up": "check-up",
            "followup": "follow-up",
            "checkup": "check-up",
            "lab test": "test",
            "labtest": "test",
            "test": "test",
            "radiology": "radiology",
            "treatment": "treatment",
            "x-ray": "radiology",
            "xray": "radiology",
            "prescription": "prescription",
            "physical exam": "consultation",
            "diagnose": "consultation",
            "diagnosis": "consultation",
            "history": "consultation"
        };

        return tabMapping[nameLC] || "consultation";
    };

    useEffect(() => {
        setSidebar(false);

        const loadAppointmentData = async () => {
            await fetchAppointmentDetails();

            if (location.state?.activeTab) {
                setActiveTab(location.state.activeTab);
            } else if (location.state?.procedureName) {
                const tabKey = getProcedureTabMapping(location.state.procedureName);
                setActiveTab(tabKey);
            }
        };

        loadAppointmentData();
    }, [id, AuthToken]);



    const fetchAppointmentDetails = async () => {
        try {
            setLoading(true);
            const AuthToken = localStorage.getItem("authToken");
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/appointments-show/${id}`,
                { headers: { Authorization: `Bearer ${AuthToken}` } }
            );

            if (response.data.appointment) {
                setAppointment(response.data.appointment);
                setError(null);
            }
        } catch (err) {
            console.error("Error fetching appointment:", err);
            setError("Failed to load appointment details");
        } finally {
            setLoading(false);
        }
    };

    const fetchFilterData = async () => {
        try {
            const AuthToken = localStorage.getItem("authToken");
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/pets`, {
                headers: { Authorization: `Bearer ${AuthToken}` }
            });
            setBreeds(res.data.breeds);
            setCustomers(res.data.customers);
        } catch (err) {
            console.error(err);
        }
    };

    const openEditPetModal = async () => {
        try {
            const AuthToken = localStorage.getItem("authToken");
            await fetchFilterData();

            const res = await axios.get(`${process.env.REACT_APP_API_URL}/pets-edit/${appointment.pet_id}`, {
                headers: { Authorization: `Bearer ${AuthToken}` }
            });

            setUpdateForm({
                id: res.data.pet.id,
                name: res.data.pet.name || '',
                breed_id: res.data.pet.breed_id || '',
                customer_id: res.data.pet.customer_id || '',
                age: res.data.pet.age || '',
                color: res.data.pet.color || '',
                male: res.data.pet.male ? '1' : '0',
                is_dead: res.data.pet.is_dead || false,
                birth_date: res.data.pet.birth_date || '',
                death_date: res.data.pet.death_date || '',
                weight: res.data.pet.weight || ''
            });
            setUpdateErrors({});
            setEditPetModal(true);
        } catch (err) {
            console.error(err);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Failed to load pet details",
            });
        }
    };

    const handleUpdateChange = (e) => {
        const { name, value, type, checked } = e.target;
        setUpdateForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
        if (updateErrors[name]) setUpdateErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleUpdateSubmit = async (e) => {
        e.preventDefault();
        setUpdateLoading(true);
        setUpdateErrors({});

        const submitData = {
            ...updateForm,
            male: parseInt(updateForm.male)
        };

        try {
            const AuthToken = localStorage.getItem("authToken");
            const res = await axios.post(
                `${process.env.REACT_APP_API_URL}/pets-update/${updateForm.id}`,
                submitData,
                { headers: { Authorization: `Bearer ${AuthToken}` } }
            );

            if (res.data.success) {
                await fetchAppointmentDetails();
                setEditPetModal(false);
                Swal.fire({
                    icon: 'success',
                    title: t('success'),
                    text: t('Pet updated successfully!'),
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                });
            }
        } catch (err) {
            if (err.response?.status === 422) {
                setUpdateErrors(err.response.data.errors || {});
                Swal.fire({
                    icon: 'error',
                    title: t('error'),
                    text: t('Please check the form for errors'),
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: t('error'),
                    text: t('Failed to update pet'),
                });
            }
        } finally {
            setUpdateLoading(false);
        }
    };

    const getBreedOptions = () => {
        let breedsArray = Array.isArray(breedsList) ? breedsList : [];

        const options = [];

        breedsArray.forEach(breed => {
            if (breed && breed.id && breed.name) {
                options.push({
                    value: breed.id,
                    label: breed.name
                });

                if (
                    breed.child_breeds &&
                    Array.isArray(breed.child_breeds) &&
                    breed.child_breeds.length > 0
                ) {
                    breed.child_breeds.forEach(child => {
                        if (child && child.id && child.name) {
                            options.push({
                                value: child.id,
                                label: `${breed.name} - ${child.name}`
                            });
                        }
                    });
                }
            }
        });

        return options;
    };

    const getProcedureOptions = () => {
        return proceduresList.map(proc => ({
            value: proc.id,
            label: proc.name
        }));
    };

    const genderOptions = [
        { value: 'male', label: 'Male' },
        { value: 'female', label: 'Female' }
    ];

    if (loading) {
        return (
            <PageLayout>
                <div className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-3">{t('loading')}</p>
                </div>
            </PageLayout>
        );
    }

    if (error) {
        return (
            <PageLayout>
                <Alert variant="danger" className="m-4">
                    {error}
                </Alert>
            </PageLayout>
        );
    }

    if (!appointment) {
        return (
            <PageLayout>
                <Alert variant="warning" className="m-4">
                    Appointment not found
                </Alert>
            </PageLayout>
        );
    }

    const isAppointmentOpen = appointment.status && !['completed', 'cancelled', 'missed'].includes(appointment.status.toLowerCase());

    return (
        <PageLayout>

            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{t('Appointments details')} </h3> <h3>
                                Reason: {appointment.pet_procedure?.[0]?.procedure?.name || 'N/A'}
                            </h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item">
                                    <Link to='#' className="mc-breadcrumb-link">{t('home')}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">
                                    <Link to='/appointments' className="mc-breadcrumb-link">{t('appointments')}</Link>
                                </li>
                                <li className="mc-breadcrumb-item">{t('Appointments details')}</li>
                            </ul>
                        </div>
                    </div>
                </Col>

                <div className="d-flex flex-wrap gap-2 justify-content-end mb-4">
                    <button
                        className="btn btn-sm text-white"
                        style={{ backgroundColor: '#004d4d' }}
                        onClick={() =>
                            window.open(
                                `${process.env.REACT_APP_URL}/appointment-print/${appointment.id}`,
                                "_blank"
                            )
                        }
                    >
                        <i className="mc-icon"></i> {t('appointment prescription')}
                    </button>

                    <button
                        className="btn btn-sm text-white"
                        style={{ backgroundColor: '#28a745' }}
                        onClick={handleOpenAddAppointment}
                    >
                        <i className="mc-icon"></i> + {t('Add More Appointment')}
                    </button>
                </div>

                <Col xl={12}>
                    <div className="mc-card p-4">
                        <Row>
                            <Col md={6} className="border-end">
                                <div className="d-flex align-items-center mb-3">
                                    <div
                                        className="d-flex align-items-center justify-content-center me-2"
                                        style={{
                                            width: '50px',
                                            height: '50px',
                                            borderRadius: '50%',
                                            background: '#e2e8f0'
                                        }}
                                    >
                                        <FiUser size={24} color="#4a5568" />
                                    </div>
                                    <h4 className="m-0">
                                        {appointment.customer?.name || 'N/A'}
                                    </h4>
                                </div>
                                <h6 className="text-muted mb-3">{t('client information')}</h6>
                                <div className="mc-pet-info-grid">
                                    <p><strong>{t('email')}:</strong> {appointment.customer?.email || 'N/A'}</p>
                                    <p><strong>{t('phone')}:</strong> {appointment.customer?.phone || 'N/A'}</p>
                                    <p><strong>{t('address')}:</strong> {appointment.customer?.address || 'N/A'}</p>
                                </div>
                            </Col>

                            <Col md={6} className="ps-md-4">
                                <div className="d-flex align-items-center mb-3">
                                    <div
                                        className="d-flex align-items-center justify-content-center me-2"
                                        style={{
                                            width: '50px',
                                            height: '50px',
                                            borderRadius: '50%',
                                            background: '#e2e8f0'
                                        }}
                                    >
                                        <FaPaw size={22} color="#4a5568" />
                                    </div>
                                    <h4 className="m-0">{appointment.pet?.name || 'N/A'}</h4>
                                </div>

                                <div className="mb-3">
                                    <ButtonComponent
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={openEditPetModal}
                                    >
                                        <FiEdit2 size={16} className="me-1" />
                                        {t('Edit Pet')}
                                    </ButtonComponent>
                                </div>

                                <h6 className="text-muted mb-3">{t('pet information')}</h6>
                                <div className="mc-pet-info-grid">
                                    <p><strong>{t('color')}:</strong> {appointment.pet?.color || 'N/A'}</p>
                                    <p>
                                        <strong>{t('gender')}:</strong>
                                        {appointment.pet?.male === 1 ? 'Male' :
                                            appointment.pet?.male === 0 ? 'Female' : 'N/A'}
                                    </p>
                                    <p><strong>{t('breed')}:</strong> {appointment.pet?.breed?.name || 'N/A'}</p>
                                    <p><strong>{t('dob')}:</strong> {moment(appointment.pet?.birth_date ?? 'N/A').format("DD MMM YYYY")}</p>
                                    {appointment.pet?.weight && (
                                        <p><strong>{t('Weight')}:</strong> {appointment.pet.weight} kg</p>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>

                <Col xl={12}>
                    <div className="mc-card">
                        <Tabs
                            activeKey={activeTab}
                            onSelect={(k) => setActiveTab(k)}
                            id="mc"
                            className="mc-tabs "
                            mountOnEnter={true}
                            unmountOnExit={false}
                            style={{ borderBottom: '1px solid black', paddingBottom: '20px', gap: '5px' }}
                        >
                            <Tab eventKey="consultation" title={t('consultation')} className="mc-tabpane">
                                <div className="mt-1 ">
                                    <Tabs
                                        defaultActiveKey="history"
                                        id="consultation-subtabs"
                                        className="mc-tabs"
                                        fill
                                        style={{ gap: '5px' }}
                                        justify
                                        mountOnEnter={true}
                                        unmountOnExit={false}
                                    >

                                        <Tab eventKey="history" title={t('history')}>
                                            <PetHistoryComponent appointmentId={appointment.id} petId={appointment.pet_id} isAppointmentOpen={isAppointmentOpen} />
                                        </Tab>



                                        <Tab eventKey="physical-exam" title={t('Physical Exam')}>
                                            <PetPhysicalExamComponent appointmentId={appointment.id} petId={appointment.pet_id} isAppointmentOpen={isAppointmentOpen} />
                                        </Tab>



                                        <Tab eventKey="diagnose" title={t('Diagnose')}>
                                            <PetDiagnoseComponent appointmentId={appointment.id} petId={appointment.pet_id} isAppointmentOpen={isAppointmentOpen} />
                                        </Tab>

                                    </Tabs>
                                </div>
                            </Tab>


                            <Tab eventKey="follow-up" title={t('Follow Up')}>
                                <PetFollowUpComponent appointmentId={appointment.id} petId={appointment.pet_id} doctorId={appointment.doctor_id} isAppointmentOpen={isAppointmentOpen} />
                            </Tab>



                            <Tab eventKey="check-up" title={t('Check Up')}>
                                <PetCheckUpComponent appointmentId={appointment.id} petId={appointment.pet_id} doctorId={appointment.doctor_id} isAppointmentOpen={isAppointmentOpen} />
                            </Tab>



                            <Tab eventKey="treatment" title={t('Treatment')}>
                                <div className="mt-1">
                                    <Tabs
                                        defaultActiveKey="treatment_main"
                                        id="treatment-subtabs"
                                        className="mc-tabs"
                                        fill
                                        justify
                                        mountOnEnter={true}
                                        unmountOnExit={false}
                                        style={{ gap: '5px' }}
                                    >
                                        <Tab eventKey="treatment_main" title={t('Treatment')}>
                                            <PetTreatmentComponent appointmentId={appointment.id} petId={appointment.pet_id} doctorId={appointment.doctor_id} isAppointmentOpen={isAppointmentOpen} />
                                        </Tab>

                                        <Tab eventKey="treatment_prescription" title={t('In House Prescription')}>
                                            <PetInhousePrescriptionComponent appointmentId={appointment.id} petId={appointment.pet_id} isAppointmentOpen={isAppointmentOpen} />
                                        </Tab>
                                    </Tabs>
                                </div>
                            </Tab>



                            <Tab eventKey="surgery" title={t('Surgery')}>
                                <div className="mt-1">
                                    <Tabs
                                        defaultActiveKey="surgery_main"
                                        id="surgery-subtabs"
                                        className="mc-tabs"
                                        fill
                                        justify
                                        mountOnEnter={true}
                                        unmountOnExit={false}
                                        style={{ gap: '5px' }}
                                    >
                                        <Tab eventKey="surgery_main" title={t('Surgery')}>
                                            <PetSurgeryComponent appointmentId={appointment.id} petId={appointment.pet_id} isAppointmentOpen={isAppointmentOpen} />
                                        </Tab>

                                        <Tab eventKey="surgery_prescription" title={t('In House Prescription')}>
                                            <PetInhousePrescriptionComponent appointmentId={appointment.id} petId={appointment.pet_id} isAppointmentOpen={isAppointmentOpen} />
                                        </Tab>
                                    </Tabs>
                                </div>
                            </Tab>



                            <Tab eventKey="vaccine" title={t('vaccine')}>
                                <PetVaccineComponent appointmentId={appointment.id} petId={appointment.pet_id} isAppointmentOpen={isAppointmentOpen} />
                            </Tab>


                            <Tab eventKey="deworming" title={t('deworming')}>
                                <PetDewormingComponent appointmentId={appointment.id} petId={appointment.pet_id} isAppointmentOpen={isAppointmentOpen} />
                            </Tab>



                            <Tab eventKey="grooming" title={t('grooming')}>
                                <PetGroomingComponent appointmentId={appointment.id} petId={appointment.pet_id} doctorId={appointment.doctor_id} isAppointmentOpen={isAppointmentOpen} />
                            </Tab>



                            <Tab eventKey="test" title={t('Lab Test')}>
                                <PetLabTestComponent appointmentId={appointment.id} petId={appointment.pet_id} isAppointmentOpen={isAppointmentOpen} />
                            </Tab>



                            <Tab eventKey="radiology" title={t('Radiology')}>
                                <PetRadiologyComponent appointmentId={appointment.id} petId={appointment.pet_id} isAppointmentOpen={isAppointmentOpen} />
                            </Tab>



                            <Tab eventKey="prescription" title={t('prescription')} className="mc-tabpane">
                                <div className="mt-3">
                                    <Tabs
                                        defaultActiveKey="in_house_prescription"
                                        id="prescription-subtabs"
                                        className="mc-tabs"
                                        fill
                                        justify
                                        mountOnEnter={true}
                                        unmountOnExit={false}
                                    >
                                        <Tab eventKey="in_house_prescription" title={t('In House Prescription')}>
                                            <PetInhousePrescriptionComponent appointmentId={appointment.id} petId={appointment.pet_id} isAppointmentOpen={isAppointmentOpen} />
                                        </Tab>

                                        <Tab eventKey="home_prescription" title={t('Home Prescription')}>
                                            <PetHomePrescriptionComponent appointmentId={appointment.id} petId={appointment.pet_id} isAppointmentOpen={isAppointmentOpen} />
                                        </Tab>
                                    </Tabs>
                                </div>
                            </Tab>



                            <Tab eventKey="sale" title={t('Sale')}>
                                <CustomerSaleComponent appointmentId={appointment.id} petId={appointment.pet_id} isAppointmentOpen={isAppointmentOpen} />
                            </Tab>


                            <Tab eventKey="invoice" title={t('Payments')} mountOnEnter={true}
                                unmountOnExit={true}>
                                <PetInvoiceComponent appointmentId={appointment.id} petId={appointment.pet_id} customerId={appointment.customer_id} isAppointmentOpen={isAppointmentOpen} />
                            </Tab>

                        </Tabs>
                    </div>
                </Col>
            </Row>

            {/* EDIT PET MODAL */}
            <Modal
                show={editPetModal}
                onHide={() => setEditPetModal(false)}
                centered
                size="lg"
            >
                <Modal.Header closeButton className="p-2">
                    <Modal.Title>{t('Edit Pet')}</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleUpdateSubmit}>
                    <Modal.Body>
                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>{t('name')} <span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        value={updateForm.name}
                                        onChange={handleUpdateChange}
                                        isInvalid={!!updateErrors.name}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {updateErrors.name?.[0]}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>{t('breed')} <span className="text-danger">*</span></Form.Label>
                                    <Form.Select
                                        name="breed_id"
                                        value={updateForm.breed_id}
                                        onChange={handleUpdateChange}
                                        isInvalid={!!updateErrors.breed_id}
                                    >
                                        <option value="">{t('select breed')}</option>
                                        {breeds.map(parent => (
                                            <React.Fragment key={parent.id}>
                                                <option disabled style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
                                                    {parent.name} {parent.type && `(${parent.type})`}
                                                </option>
                                                {parent.child_breeds?.map(child => (
                                                    <option key={child.id} value={child.id}>
                                                        {"\u00A0\u00A0\u00A0\u00A0"}{child.name} {child.type && `(${child.type})`}
                                                    </option>
                                                ))}
                                            </React.Fragment>
                                        ))}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {updateErrors.breed_id?.[0]}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>{t('customer')} <span className="text-danger">*</span></Form.Label>
                                    <Form.Select
                                        name="customer_id"
                                        value={updateForm.customer_id}
                                        onChange={handleUpdateChange}
                                        isInvalid={!!updateErrors.customer_id}
                                    >
                                        <option value="">{t('select customer')}</option>
                                        {customers.map(c => (
                                            <option key={c.id} value={c.id}>
                                                {c.name} {c.type && `(${c.type})`}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {updateErrors.customer_id?.[0]}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>{t('age')}</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="age"
                                        value={updateForm.age}
                                        onChange={handleUpdateChange}
                                        min="0"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>{t('color')}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="color"
                                        value={updateForm.color}
                                        onChange={handleUpdateChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>{t('gender')}</Form.Label>
                                    <Form.Select
                                        name="male"
                                        value={updateForm.male}
                                        onChange={handleUpdateChange}
                                    >
                                        <option value="1">{t('Male')}</option>
                                        <option value="0">{t('Female')}</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>{t('weight (kg)')}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="weight"
                                        value={updateForm.weight}
                                        onChange={handleUpdateChange}
                                        placeholder={t('Enter pet weight')}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={6}>
                                <Form.Group>
                                    <Form.Label>{t('birth date')}</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="birth_date"
                                        value={updateForm.birth_date}
                                        onChange={handleUpdateChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row className="mb-3">
                            <Col md={12}>
                                <Form.Group>
                                    <Form.Check
                                        type="checkbox"
                                        label={t('is dead')}
                                        name="is_dead"
                                        checked={updateForm.is_dead}
                                        onChange={handleUpdateChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {updateForm.is_dead && (
                            <Row className="mb-3">
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>{t('death date')}</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="death_date"
                                            value={updateForm.death_date}
                                            onChange={handleUpdateChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}
                    </Modal.Body>

                    <Modal.Footer className="p-2">
                        <ButtonComponent
                            className="btn btn-secondary"
                            onClick={() => setEditPetModal(false)}
                        >
                            {t('cancel')}
                        </ButtonComponent>
                        <ButtonComponent
                            className="btn btn-primary"
                            type="submit"
                            disabled={updateLoading}
                        >
                            {updateLoading && (
                                <span className="spinner-border spinner-border-sm me-2"></span>
                            )}
                            {t('update')}
                        </ButtonComponent>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* ADD MORE APPOINTMENT MODAL */}
            <Modal
                show={showAddAppointmentModal}
                onHide={() => setShowAddAppointmentModal(false)}
                centered
                size="md"
            >
                <Modal.Header closeButton className="p-3">
                    <Modal.Title className="fw-bold">
                        {t('Add Additional Appointment')}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-4">
                        {/* Pet Selection */}
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                                {t('Select Pet')} <span className="text-danger">*</span>
                            </Form.Label>
                            {loadingPets ? (
                                <div className="text-center py-3">
                                    <Spinner animation="border" size="sm" />
                                    <span className="ms-2">{t('Loading pets...')}</span>
                                </div>
                            ) : (
                                <div>
                                    <Select
                                        options={availablePets.map(pet => ({
                                            value: pet.id,
                                            label: `🐾 ${pet.name} - ${pet.breed?.name || 'Unknown Breed'} - ${pet.color || ''}`,
                                            pet: pet
                                        }))}
                                        value={selectedPet}
                                        onChange={setSelectedPet}
                                        placeholder={t("Select a pet")}
                                        isClearable
                                        styles={{
                                            container: (provided) => ({ ...provided, width: "100%" }),
                                            control: (provided) => ({ ...provided, height: "42px" })
                                        }}
                                    />

                                    {/* Create New Pet Button - Always visible, styled as a proper button */}
                                    <div className="mt-3">
                                        <ButtonComponent
                                            className="btn btn-outline-primary btn-sm w-100"
                                            onClick={() => {
                                                setShowAddAppointmentModal(false);
                                                fetchBreedsList();
                                                setShowPetCreationModal(true);
                                            }}
                                        >
                                            <i className="bi bi-plus-circle me-1"></i> + {t('Create New Pet')}
                                        </ButtonComponent>
                                    </div>
                                </div>
                            )}
                        </Form.Group>



                        {/* Procedure Selection */}
                        {selectedPet && (
                            <>
                                <Form.Label className="fw-bold mt-2">
                                    {t('Select Procedures')} <span className="text-muted">({t('optional')})</span>
                                </Form.Label>
                                <Select
                                    options={getProcedureOptions()}
                                    value={selectedProcedures}
                                    onChange={setSelectedProcedures}
                                    placeholder={t("Select procedures...")}
                                    styles={{
                                        container: (provided) => ({ ...provided, width: "100%" }),
                                    }}
                                />
                            </>
                        )}
                    </div>

                    <Alert variant="secondary" className="mb-0">
                        <small>
                            <i className="bi bi-info-circle me-1"></i>
                            {t('You will be redirected to the new appointment page where you can add more procedures, notes, and payments if needed.')}
                        </small>
                    </Alert>
                </Modal.Body>
                <Modal.Footer className="p-3">
                    <ButtonComponent
                        className="btn btn-secondary"
                        onClick={() => setShowAddAppointmentModal(false)}
                    >
                        {t('Cancel')}
                    </ButtonComponent>
                    <ButtonComponent
                        className="btn btn-success"
                        onClick={handleCreateAdditionalAppointment}
                        disabled={!selectedPet || creatingAppointment}
                    >
                        {creatingAppointment && (
                            <Spinner animation="border" size="sm" className="me-2" />
                        )}
                        {t('Create Appointment')}
                    </ButtonComponent>
                </Modal.Footer>
            </Modal>

            {/* CREATE NEW PET MODAL */}
            <Modal
                show={showPetCreationModal}
                onHide={() => {
                    setShowPetCreationModal(false);
                    setNewPetForm({
                        name: '',
                        breed_id: '',
                        age: '',
                        color: '',
                        male: '',
                        weight: '',
                        birth_date: ''
                    });
                    setNewPetErrors({});
                }}
                centered
                size="md"
            >
                <Modal.Header closeButton className="p-3">
                    <Modal.Title className="fw-bold">
                        {t('Create New Pet for')} {appointment.customer?.name}
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleCreateNewPet}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                                {t('Pet Name')} <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                                type="text"
                                name="name"
                                value={newPetForm.name}
                                onChange={handleNewPetChange}
                                isInvalid={!!newPetErrors.name}
                                placeholder={t("Enter pet name")}
                            />
                            <Form.Control.Feedback type="invalid">
                                {newPetErrors.name}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                                {t('Breed')} <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Select
                                name="breed_id"
                                value={newPetForm.breed_id}
                                onChange={handleNewPetChange}
                                isInvalid={!!newPetErrors.breed_id}
                            >
                                <option value="">{t('select breed')}</option>
                                {breeds.map(parent => (              // ✅ breedsList → breeds
                                    <React.Fragment key={parent.id}>
                                        <option disabled style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>
                                            {parent.name} {parent.type && `(${parent.type})`}
                                        </option>
                                        {parent.child_breeds?.map(child => (
                                            <option key={child.id} value={child.id}>
                                                {"\u00A0\u00A0\u00A0\u00A0"}{child.name} {child.type && `(${child.type})`}
                                            </option>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                                {newPetErrors.breed_id}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">
                                {t('Gender')} <span className="text-danger">*</span>
                            </Form.Label>
                            <Select
                                options={genderOptions}
                                value={genderOptions.find(opt => opt.value === newPetForm.male)}
                                onChange={(selected) => {
                                    setNewPetForm(prev => ({ ...prev, male: selected ? selected.value : "" }));
                                    if (newPetErrors.male) setNewPetErrors(prev => ({ ...prev, male: "" }));
                                }}
                                placeholder={t("Select Gender")}
                                styles={{
                                    container: (provided) => ({ ...provided, width: "100%" }),
                                    control: (provided) => ({ ...provided, height: "42px" })
                                }}
                            />
                            {newPetErrors.male && <span className="text-danger small">{newPetErrors.male}</span>}
                        </Form.Group>

                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-bold">{t('Age')}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="age"
                                        value={newPetForm.age}
                                        onChange={handleNewPetChange}
                                        placeholder={t("Enter age (e.g., 2 years)")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-bold">{t('Color')}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="color"
                                        value={newPetForm.color}
                                        onChange={handleNewPetChange}
                                        placeholder={t("Enter color")}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-bold">{t('Weight (kg)')}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="weight"
                                        value={newPetForm.weight}
                                        onChange={handleNewPetChange}
                                        placeholder={t("Enter weight")}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-bold">{t('Birth Date')}</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="birth_date"
                                        value={newPetForm.birth_date}
                                        onChange={handleNewPetChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer className="p-3">
                        <ButtonComponent
                            className="btn btn-secondary"
                            onClick={() => {
                                setShowPetCreationModal(false);
                                setShowAddAppointmentModal(true);
                            }}
                        >
                            {t('Cancel')}
                        </ButtonComponent>
                        <ButtonComponent
                            className="btn btn-primary"
                            type="submit"
                            disabled={creatingPet}
                        >
                            {creatingPet && (
                                <Spinner animation="border" size="sm" className="me-2" />
                            )}
                            {t('Create Pet')}
                        </ButtonComponent>
                    </Modal.Footer>
                </Form>
            </Modal>
        </PageLayout>
    );
}